
import { Component, Ref, Vue } from 'vue-property-decorator'
import ProofreadProblemInput from '@/components/templates/manage/ProofreadProblemInput.vue'
import { StudyModel } from '@/models/StudyModel'
import { CurriculumUnit } from '@/models/CurriculumUnit'
import { ProblemsApi } from '@/api/methods/ProblemsApi'
import { CurriculumUnitsApi } from '@/api/methods/CurriculumUnitsApi'
import { QuestionsApi } from '@/api/methods/proofread/QuestionsApi'

/**
 * 校正画面-解答入力画面(知識マップ)
 */
@Component({
  components: {
    ProofreadProblemInput,
  },
})
export default class AcademyLearningMapProblemInput extends Vue {
  /** 解答入力画面テンプレート */
  @Ref()
  proofreadProblemInput!: ProofreadProblemInput

  /** 読み込み完了フラグ */
  private isLoaded = false

  /** 教科コード */
  private subjectCode!: string

  /** 単元情報 */
  private curriculumUnit!: CurriculumUnit

  /** 小問情報 */
  private problem?: StudyModel.Problem

  /**
   * 単元ID
   *
   * @returns パスから取得した単元ID
   */
  private get curriculumUnitId(): number {
    return Number(this.$route.params.curriculumUnitId)
  }

  /**
   * 小問ID
   *
   * @returns パスから取得した小問ID
   */
  private get problemId(): number {
    return Number(this.$route.params.problemId)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()

    // 問題情報取得
    const problem = await ProblemsApi.getProblemCorrect(this.problemId)

    // 小問情報を生成
    this.problem = new StudyModel.Problem(problem.code, problem.imageDescriptions, problem.imageGuidances || [])

    // 設問情報を生成
    problem.questions.forEach((question) => {
      // undefinedブロック(実際には発生しない)
      if (!this.problem) {
        return
      }

      // 設問情報を追加(正誤結果は固定値を送る)
      this.problem.addQuestionByResponse(question, true)
    })

    // 単元情報設定
    const curriculumUnit = await CurriculumUnitsApi.getCurriculumUnit(this.curriculumUnitId)
    this.curriculumUnit = {
      id: curriculumUnit.id,
      name: curriculumUnit.name,
    }
    this.subjectCode = curriculumUnit.subjectCode

    this.isLoaded = true

    this.$loading.complete()
  }

  /**
   * 答え合わせボタン押下時の処理
   *
   * @param question 設問情報
   */
  private async eventSubmit(question: StudyModel.Question): Promise<void> {
    // 入力情報と問題情報から正誤判定処理を呼び出す
    const questionCorrect = await QuestionsApi.getCorrect(question.id, question.inputValues)

    // 取得結果を使いモーダルを表示
    this.proofreadProblemInput.showResultModal(question, questionCorrect.correctInputText, questionCorrect.isCorrect)
  }

  /**
   * 問題選択画面への遷移処理
   */
  private async eventReturn(): Promise<void> {
    await this.$router.push(`/academy/map/${this.curriculumUnit.id}`)
  }

  /**
   * 単元選択画面への遷移処理
   */
  private async eventTopPage(): Promise<void> {
    await this.$router.push({
      path: '/academy/map',
      query: {
        subject: this.subjectCode,
      },
    })
  }
}
